
import { create } from "zustand";
import { Member } from "../Member/Member.Current";
import { API } from "@swivl-mono/api-helper";
import { LeaseInterface } from "../../../../../libs/types/src";

interface StoreInterface {
  leases?: LeaseInterface[]
  isLoading: boolean;
}
const BlankState: StoreInterface = {
  leases: undefined,
  isLoading: true,
};
export default class LeasesModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = LeasesModel.useState.setState;
  static get state() {
    return LeasesModel.useState.getState();
  }
  static reset() {
    LeasesModel.setState({ ...BlankState });
  }

  static async getLeasesByUserId(userId: number, includeUnit: boolean = false) {
    LeasesModel.setState({ isLoading: true });
    
    let leases: LeaseInterface[] = await API.Leases.getLeasesByUserId(Member.orgId!, userId, includeUnit)
    await API.Leases.getLeasesByUserId(Member.orgId!, userId)

    LeasesModel.setState({ isLoading: false, leases: leases });
  }
}
